
import * as React from 'react';
import { useEffect, useState } from "react";
import { DestinationCard, WeatherDataSimplified } from './card';
import { RegionBase } from '../../templates/fragments/region';
import ensureMonthIndexInRange from '../../services/ensureMonthIndexInRange';
import getLocationPath from '../../services/getLocationPath';
import { monthSlugsWithOverview } from '../../services/centralStore';
import _ from 'lodash';
import { useLoc } from '../../hooks/useLoc';
import { useMonth } from '../../hooks/useMonth';
import { ResortBase } from '../../templates/fragments/resort';
import { WeatherSearchResultRowComplete } from '../../services/weatherSearch';
import { FadedOverlay } from './base/faded-ovelay';
import { ScrollButtons } from './base/scroll-buttons';
import { useDraggableContainer } from '../../hooks/useDraggableContainer';
import { useElementSize } from '../../hooks/useElementSize';
import { useScrollHandler } from '../../hooks/useScrollHandler';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { setHoveredRegion } from '../../store/weatherSearchSlice';

export const DestinationCards = ({ regionsOrResorts, className, useSlugName, isResorts, includeCountry }: { regionsOrResorts: RegionBase[] | ResortBase[], className?: string, useSlugName?: boolean, isResorts?: boolean, includeCountry?: boolean }) => {

    return (

        <div className={`m-auto flex flex-wrap max-w-[1500px] ts:px-8 md:px-12
        gap-[20px] sm:gap-[32px] justify-center ${className}`}>
            <DestinationCardsInternal {...{ regionsOrResorts, useSlugName, isResorts, includeCountry }} />
        </div>)
}

export const DestinationCardsSearch = ({ regions, inRow, className }: { regions: WeatherSearchResultRowComplete[], inRow?: boolean, className?: string }) => {
    const dispatch = useAppDispatch();
    const scrollRef = React.useRef<null | any>(null);
    const { needEdgeOverlay, isDragging } = useDraggableContainer(scrollRef, true);
    const firstCard = (scrollRef?.current?.children || [])[0]
    const scrollDiff = useElementSize({ el: firstCard });
    const width = useElementSize({});
    const scrollHandler = useScrollHandler({ ref: scrollRef });
    const onScroll = ({ isLeft }: { isLeft: boolean }) => {
        scrollHandler((scrollDiff + 8) * (isLeft ? -1 : 1) * (width > 400 ? 2 : 1));
    };
    return (
        <DestinationCardsWrapper inRow={inRow}>
            <div ref={scrollRef} className={inRow ? `gap-x-[6px] flex flex-row overflow-x-auto ${className} ${isDragging ? 'scroll-auto' : 'scroll-smooth'}` : `m-auto pb-[20px] flex flex-wrap gap-y-2 ${className}`}>
                <DestinationCardsInternal
                    regionsOrResorts={regions}
                    includeCountry={true}
                    forceVerySmall={inRow}
                    forceSmall={true}
                    onHover={(hovered: boolean, slug: string) => {
                        dispatch(setHoveredRegion(hovered ? slug : undefined));
                    }}
                />
            </div>
            {inRow && regions.length > 2 && <FadedOverlay fadeLeft={needEdgeOverlay.left} fadeRight={needEdgeOverlay.right} isBigger={true}></FadedOverlay>}
            {(inRow && regions.length > 2 && (needEdgeOverlay.left || needEdgeOverlay.right)) &&
                <ScrollButtons fadeLeft={needEdgeOverlay.left} fadeRight={needEdgeOverlay.right}
                    onClick={onScroll}
                />}
        </DestinationCardsWrapper>
    )
}

const DestinationCardsWrapper = ({ inRow, children }) => {
    return inRow ? <div className={`absolute left-0 right-0 h-[188px]`}>
        {children}
    </div> : <>{children}</>

}

const DestinationCardsInternal = ({ regionsOrResorts, useSlugName, isResorts, includeCountry, forceSmall, forceVerySmall, onHover }: { regionsOrResorts: RegionBase[] | ResortBase[] | WeatherSearchResultRowComplete[], useSlugName?: boolean, isResorts?: boolean, includeCountry?: boolean, forceSmall?: boolean, forceVerySmall?: boolean, onHover?: (hovered: boolean, slug: string) => void }) => {
    let { month } = useMonth({ ignoreOverview: true });
    const loc = useLoc();
    const monthIndex = monthSlugsWithOverview.indexOf(month);

    return (
        <>
            {regionsOrResorts.map((regionOrResort: RegionBase | ResortBase | WeatherSearchResultRowComplete) => regionOrResort.mainImg &&
                <DestinationCard imageDataLike={regionOrResort.mainImg.childImageSharp.gatsbyImageData}
                    partOfTheWorld={loc(`common.continents.${isResorts ? (regionOrResort as ResortBase).region.country.continent : (regionOrResort as RegionBase).country.continent}`)}
                    lazyLoad={true}
                    key={regionOrResort.slug}
                    originalSlug={regionOrResort.slug}
                    tags={regionOrResort.tags}
                    includeCountry={(isResorts || !(regionOrResort as RegionBase).isCountry) ? includeCountry : false}
                    forceSmall={forceSmall}
                    forceVerySmall={forceVerySmall}
                    countryName={isResorts ? (regionOrResort as ResortBase).region.country.name : (regionOrResort as RegionBase).country.name}
                    location={useSlugName ? (regionOrResort.slugName || regionOrResort.name) : regionOrResort.name}
                    weatherData={regionOrResort.weatherData}
                    monthIndexes={(regionOrResort as WeatherSearchResultRowComplete).monthIndexes}
                    slug={getLocationPath({ location: regionOrResort, isCountryInstance: false, isResortInstance: isResorts, monthIndex })}
                    onHover={onHover}
                />
            )}
        </>
    )
}